export default __webpack_public_path__ + "static/media/hollowCircle.906f5f7b.svg";